//可使用 https://github.com/LavaGiant/Xlsx2data.git 工具快速录入数据
export const TYPE_INFO_TABLE_DETAIL = {
  "label": [
    {
      "mark": "rna",
      "labelName": "RNA合成",
      "labelCover": "/static/img/product-service/rna-compose/rna_compose.png"
    },
    {
      "mark": "plasmid",
      "labelName": "质粒",
      "labelCover": "/static/img/product-service/rna-compose/plasmid.png"
    }
  ],
  "content": [
    {
      "mark": "rna",
      "label": "RNA合成",
      "header": {
        "num": "货号",
        "goods": "产品",
        "explain": "说明"
      },
      "data": [
        {
          "num": "TSGXS101",
          "goods": "Homo-Negative Control",
          "explain": "人siRNAsiRNA阴性对照"
        },
        {
          "num": "TSGXS102",
          "goods": "Mus-Negative Control",
          "explain": "小鼠siRNA阴性对照"
        },
        {
          "num": "TSGXS103",
          "goods": "Rat-Negative Control",
          "explain": "大鼠siRNA阴性对照"
        },
        {
          "num": "TSGXS104",
          "goods": "Homo-FAM-Negative Control",
          "explain": "FAM标记人siRNAsiRNA阴性对照"
        },
        {
          "num": "TSGXS105",
          "goods": "Mus-FAM-Negative Control",
          "explain": "FAM标记小鼠siRNA阴性对照"
        },
        {
          "num": "TSGXS106",
          "goods": "Rat-FAM-Negative Control",
          "explain": "FAM标记大鼠siRNA阴性对照"
        },
        {
          "num": "TSGXM107",
          "goods": "mimics NC",
          "explain": "mimics阴性对照"
        },
        {
          "num": "TSGXM108",
          "goods": "inhibitor NC",
          "explain": "inhibitor阴性对照"
        },
        {
          "num": "TSGXA109",
          "goods": "ASO-NC",
          "explain": "ASO阴性对照"
        },
        {
          "num": "TSGXS110",
          "goods": "NC",
          "explain": "单链RNA阴性对照"
        },
        {
          "num": "TSGXM111",
          "goods": "agomir-NC",
          "explain": "agomir阴性对照"
        },
        {
          "num": "TSGXM112",
          "goods": "antagomir-NC",
          "explain": "antagomir阴性对照"
        },
        {
          "num": "TSGXS201",
          "goods": "Homo-GAPDH",
          "explain": "人siRNA-GAPDH阳性对照"
        },
        {
          "num": "TSGXS202",
          "goods": "Homo-β-actin",
          "explain": "人siRNA-beta-actin阳性对照"
        },
        {
          "num": "TSGXS203",
          "goods": "Mus-GAPDH",
          "explain": "小鼠siRNA-GAPDH阳性对照"
        },
        {
          "num": "TSGXS204",
          "goods": "Mus-β-actin",
          "explain": "小鼠siRNA-beta-actin阳性对照"
        },
        {
          "num": "TSGXS205",
          "goods": "Rat-GAPDH",
          "explain": "大鼠siRNA-GAPDH阳性对照"
        },
        {
          "num": "TSGXS206",
          "goods": "Rat-β-actin",
          "explain": "大鼠siRNA-beta-actin阳性对照"
        }
      ]
    },
    {
      "mark": "plasmid",
      "label": "质粒",
      "header": {
        "num": {
          "label": "货号",
          "width": "275"
        },
        "carrier": {
          "label": "载体",
          "width": "281"
        },
        "site5": {
          "label": "5’酶切位点",
          "width": "200"
        },
        "site3": {
          "label": "3’酶切位点",
          "width": "200"
        },
        "resistance": {
          "label": "真核抗性",
          "width": "200"
        },
        "color": {
          "label": "荧光",
          "width": "200"
        },
        "explain": {
          "label": "说明",
          "width": "360"
        }
      },
      "data": [
        {
          "num": "TSGXH301",
          "carrier": "plko.1-PURO",
          "site5": "AgeI",
          "site3": "EcoRI",
          "resistance": "puro",
          "color": "-",
          "explain": ""
        },
        {
          "num": "TSGXH302",
          "carrier": "plko.1-NEO",
          "site5": "AgeI",
          "site3": "EcoRI",
          "resistance": "NEO",
          "color": "-",
          "explain": ""
        },
        {
          "num": "TSGXH303",
          "carrier": "plko.1-Hygro",
          "site5": "AgeI",
          "site3": "EcoRI",
          "resistance": "Hygro",
          "color": "-",
          "explain": ""
        },
        {
          "num": "TSGXH304",
          "carrier": "plko.1-copGFP-PURO",
          "site5": "AgeI",
          "site3": "EcoRI",
          "resistance": "puro",
          "color": "绿",
          "explain": ""
        },
        {
          "num": "TSGXH305",
          "carrier": "plko.1-LUC-PURO",
          "site5": "AgeI",
          "site3": "EcoRI",
          "resistance": "puro",
          "color": "黄橙",
          "explain": ""
        },
        {
          "num": "TSGXH306",
          "carrier": "plko.1-mCherry-PURO",
          "site5": "AgeI",
          "site3": "EcoRI",
          "resistance": "puro",
          "color": "红",
          "explain": ""
        },
        {
          "num": "TSGXH307",
          "carrier": "plko.1-mCherry-NEO",
          "site5": "AgeI",
          "site3": "EcoRI",
          "resistance": "NEO",
          "color": "红",
          "explain": ""
        },
        {
          "num": "TSGXH308",
          "carrier": "tet-plko-PURO",
          "site5": "AgeI",
          "site3": "EcoRI",
          "resistance": "puro",
          "color": "-",
          "explain": "tet-on"
        },
        {
          "num": "TSGXG313",
          "carrier": "LentiCRISPR v2-Puro",
          "site5": "BsmbI",
          "site3": "BsmbI",
          "resistance": "puro",
          "color": "-",
          "explain": ""
        },
        {
          "num": "TSGXG314",
          "carrier": "LentiCRISPR v2-NEO",
          "site5": "BsmbI",
          "site3": "BsmbI",
          "resistance": "NEO",
          "color": "-",
          "explain": ""
        },
        {
          "num": "TSGXG315",
          "carrier": "LentiCRISPR v2-Hygro",
          "site5": "BsmbI",
          "site3": "BsmbI",
          "resistance": "Hygro",
          "color": "-",
          "explain": ""
        },
        {
          "num": "TSGXG316",
          "carrier": "LentiCRISPR v2-mCherry",
          "site5": "BsmbI",
          "site3": "BsmbI",
          "resistance": "-",
          "color": "红",
          "explain": ""
        },
        {
          "num": "TSGXG317",
          "carrier": "LentiGuide-Puro",
          "site5": "BsmbI",
          "site3": "BsmbI",
          "resistance": "puro",
          "color": "-",
          "explain": ""
        },
        {
          "num": "TSGXG318",
          "carrier": "LentiGuide-EGFP",
          "site5": "BsmbI",
          "site3": "BsmbI",
          "resistance": "-",
          "color": "绿",
          "explain": ""
        },
        {
          "num": "TSGXG319",
          "carrier": "pSpCas9(BB)-2A-GFP (PX458)",
          "site5": "BbsI",
          "site3": "BbsI",
          "resistance": "-",
          "color": "绿",
          "explain": ""
        },
        {
          "num": "TSGXG320",
          "carrier": "pSpCas9(BB)-2A-Puro (PX459) V2.0",
          "site5": "BbsI",
          "site3": "BbsI",
          "resistance": "puro",
          "color": "-",
          "explain": ""
        },
        {
          "num": "TSGXT401",
          "carrier": "lentiCas9-EGFP",
          "site5": "",
          "site3": "",
          "resistance": "-",
          "color": "绿",
          "explain": "只表达cas9"
        },
        {
          "num": "TSGXT402",
          "carrier": "Lenti-Cas9-Puro",
          "site5": "",
          "site3": "",
          "resistance": "puro",
          "color": "-",
          "explain": "只表达cas9"
        },
        {
          "num": "TSGXT403",
          "carrier": "pCW57",
          "site5": "",
          "site3": "",
          "resistance": "puro",
          "color": "-",
          "explain": "只表达cas9，tet-on"
        },
        {
          "num": "TSGXT404",
          "carrier": "PSPAX2",
          "site5": "",
          "site3": "",
          "resistance": "",
          "color": "",
          "explain": "包装质粒"
        },
        {
          "num": "TSGXT405",
          "carrier": "pmd2.G",
          "site5": "",
          "site3": "",
          "resistance": "",
          "color": "",
          "explain": "包装质粒"
        },
        {
          "num": "TSGXT406",
          "carrier": "pRSV-Rev",
          "site5": "",
          "site3": "",
          "resistance": "",
          "color": "",
          "explain": "包装质粒"
        },
        {
          "num": "TSGXT407",
          "carrier": "pMDLg-pRRE",
          "site5": "",
          "site3": "",
          "resistance": "",
          "color": "",
          "explain": "包装质粒"
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/views/products/constants.js